module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAN1JREFUeNqMlAsNxCAMhmEKkDAJSGAKhgQknIQ5mRRwMBzcHAwHXHsZyR10hSYNScv/hfUxKQjLOWs4DLi6Qwk8SCmj4AyEBtznZ/M3nBS7PG6uFtv6xnVdPYgpYoX3m7d6n621HOhdAC/yYwGAaa01B3ETXFq5wsYYxbIsIqVEpVcEaNExBqKmn153ISGEJo6AcwSw77uAopKA2BM7575O2Pk4QKULIByahYMCGGM4sf9bnnqYsPdM/zGhmg3E6RrYg4NbKBzr7QGEsa3WSGa1ZzjmUm34F5Dt/ggwAOeoERCfd873AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/sendDetails_over.png
// module id = 1020
// module chunks = 0